import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";
import {
  createNonNegativeDecimalPercentageSchema,
  nonNegativeDecimalStringSchema,
} from "@/schemas/commonFields/numberSchema";
import { PROJECT_DEPENDS_ON, ulid } from "@/schemas/commonFields";
import { emptyStringToNull } from "@/lib/utils/zod";

const nullableDecimalStringSchema = nonNegativeDecimalStringSchema.nullable();
const nullableDecimalPercentageSchema =
  createNonNegativeDecimalPercentageSchema().nullable();

const payrollType = dictionary.extend({
  split: z.boolean(),
  description: z.string().max(250).optional(),
  project_depends_on: z.enum(PROJECT_DEPENDS_ON),
  invoicing_company_id: ulid,
  invoicing_company: z.string().optional(),
  agreement_type_id: ulid,
  agreement_type: z.string(),
  administrative_fee: nullableDecimalStringSchema.optional(),
  deduction_percentage: nullableDecimalPercentageSchema.optional(),
  hours_bound_to_visits: z.boolean().optional(),
  block_timesheet_and_visits_when_payroll_created: z.boolean().optional(),
});

export const readPayrollType = payrollType.readonly();

export const createPayrollType = payrollType
  .omit({
    id: true,
    invoicing_company: true,
    agreement_type: true,
    administrative_fee: true,
    deduction_percentage: true,
  })
  .extend({
    administrative_fee: emptyStringToNull(
      nullableDecimalStringSchema,
    ).optional(),
    deduction_percentage: emptyStringToNull(
      nullableDecimalPercentageSchema,
    ).optional(),
  });

export const updatePayrollType = createPayrollType
  .pick({
    description: true,
    administrative_fee: true,
    deduction_percentage: true,
  })
  .extend({
    agreement_type_id: ulid.optional(),
    hours_bound_to_visits: z.boolean().optional(),
    block_timesheet_and_visits_when_payroll_created: z.boolean().optional(),
  });
